import AvatarCompany from "@/components/company/avatar-company";
import { Button } from "@/components/ui/button";
import { useCompanyLinkInPanel } from "@/hooks/useCompanyLinkInPanel";
import { internalLinkTarget } from "@/lib/internal-link-target";
import { CompanyDTO } from "@shaarp/common";
import { SquareArrowOutUpRight } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * An employee's company, as a link: in the bottom panel on a phone, as every
 * company link there; in a tab of its own on a desktop. A component, so the
 * cell can hold the panel's hook.
 */
export function EmployeeCompanyLink({
  companyId,
  label,
  company,
}: {
  readonly companyId: string;
  readonly label: string;
  readonly company: CompanyDTO;
}) {
  const openInPanel = useCompanyLinkInPanel();
  return (
    <Button variant="outline" size="sm" asChild>
      <Link
        to={`/company/${companyId}`}
        target={internalLinkTarget()}
        className="flex items-center gap-2"
        onClick={(event) => openInPanel(event, { id: companyId, label })}
      >
        <AvatarCompany className="size-5" company={company} />
        {label}
        <SquareArrowOutUpRight className="ml-0.5 size-3.5" />
      </Link>
    </Button>
  );
}
